import type { CBoxBackground } from '@seek/cmsu-cms-connect';
import { ContentBlock } from 'braid-design-system';
import React from 'react';

import { TestimonialCarousel } from './components/TestimonialCarousel/TestimonialCarousel';
import type { Testimonials } from './types';

export interface TestimonialsCarouselProps {
  testimonials: Testimonials;
  cardBackground?: CBoxBackground | null;
}

export const TestimonialGroup = ({
  testimonials,
  cardBackground,
}: TestimonialsCarouselProps) => (
  <ContentBlock>
    <TestimonialCarousel
      testimonials={testimonials}
      cardBackground={cardBackground}
    />
  </ContentBlock>
);
